const version = {
    version: '1.09',
    date: '2024-06-07'
};
export default version;